var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topSubMenuList"},[_c('div',{ref:"innerWrap",staticClass:"topSubMenuInnerWrap"},[_vm._l((_vm.menu),function(menu,idx){return [_c('router-link',{key:idx,staticClass:"subMenuLinkItem",attrs:{"to":menu.link}},[_vm._v(_vm._s(menu.txt))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }